"use client";

import type { HTMLAttributes, FC, Ref } from "react";
import type {
  ClassNameProp,
  EdgesProps,
  IconProp,
  RequiredChildrenProp,
} from "../../props";
import { Card, type CardProps } from "../Card/Card";
import { Text } from "../Text/Text";
import { List, type ListProps } from "../List/List";
import { Edges } from "../Edges/Edges";
import { Flex } from "../Flex/Flex";
import { titleStyles } from "./ListCard.css";

export type ListCardProps = HTMLAttributes<HTMLDivElement> &
  RequiredChildrenProp &
  ClassNameProp &
  IconProp &
  EdgesProps &
  Pick<CardProps, "border"> & {
    title?: string;
    variant: ListProps["variant"];
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLDivElement>;
  };

/**
 * A card component that displays a list of items.
 */
export const ListCard: FC<ListCardProps> = ({
  className,
  title,
  variant = "secondary",
  border = "default",
  leading,
  trailing,
  children,
  ref,
  ...props
}) => (
  <Card ref={ref} className={className} border={border} {...props}>
    {title && (
      <Text className={titleStyles} variant="bodyL" bold align="center">
        {title}
      </Text>
    )}
    <Edges
      leading={leading}
      trailing={trailing ? <Flex justify="center">{trailing}</Flex> : undefined}
    >
      <List variant={variant} size="s">
        {children}
      </List>
    </Edges>
  </Card>
);
